// Library methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Types
import { ExamSectionReportType } from "src/services/exams/types";

type D15OptionsType = {
  data: ExamSectionReportType;
  isLiveUpdate?: boolean;
};

const D15Options = ({ data, isLiveUpdate = false }: D15OptionsType) => {
  const { t } = useTranslation();

  const firstRow = data?.state?.row1 || [];
  const secondRow = data?.state?.row2 || [];
  const thirdRow = Array.from({ length: 16 }, (_, i) => i);
  const D15Colors = data?.state?.colors || [];

  return (
    <Box width="100%" display="flex" flexDirection="column" gap="8px">
      <Typography sx={{ fontSize: "14px" }}>
        {isLiveUpdate ? t("Original Colors") : t("Remaining Colors")}
      </Typography>
      <Grid container display="flex" justifyContent="space-between">
        {!firstRow || !firstRow?.length ? (
          <Typography fontSize="14px" fontWeight={600} color="#E10C0C">
            {t("Error: No patient responses recorded.")}
          </Typography>
        ) : (
          firstRow?.map((elem, index) => (
            <Grid
              item
              key={index}
              xs={12 / (firstRow.length + 4 || 1)}
              sx={{
                background: elem === -1 ? "#f2f1f4" : D15Colors[elem],
              }}
            >
              <Box height={35} />
            </Grid>
          ))
        )}
      </Grid>

      <Typography sx={{ fontSize: "14px" }}>
        {isLiveUpdate ? t("Current Progress") : t("Final Results")}
      </Typography>
      <Grid container display="flex" justifyContent="space-between">
        {!secondRow || !secondRow?.length ? (
          <Typography fontSize="14px" fontWeight={600} color="#E10C0C">
            {t("Error: No patient responses recorded.")}
          </Typography>
        ) : (
          secondRow?.map((elem, index) => (
            <Grid
              item
              key={index}
              xs={12 / (secondRow.length + 4 || 1)}
              sx={{
                background: elem === -1 ? "#f2f1f4" : D15Colors[elem],
              }}
            >
              <Box height={35} />
            </Grid>
          ))
        )}
      </Grid>

      <Typography sx={{ fontSize: "14px" }}>{t("Expected Output")}</Typography>
      <Grid container display="flex" justifyContent="space-between">
        {thirdRow.length > 0 &&
          thirdRow.map((elem, index) => (
            <Grid
              item
              key={index}
              xs={12 / (thirdRow.length + 4 || 1)}
              sx={{
                background:
                  elem === -1 ? "#f2f1f4" : D15Colors?.[elem] ?? "gray",
              }}
            >
              <Box height={35} />
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default D15Options;
